import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import Textfield from 'js/components/Textfield/Textfield'

interface VideoPropertiesProps {
    title: string
    onClose: (attrs?: { title: string }) => void
}

const VideoProperties = ({ title, onClose }: VideoPropertiesProps) => {
    const [titleInput, setTitleInput] = useState<string>(title)

    const changeTitleInput = (event: React.ChangeEvent<HTMLInputElement>) =>
        setTitleInput(event.target.value)

    const handleReset = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        onClose()
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        onClose({ title: titleInput })
    }

    const { t } = useTranslation()

    return (
        <form onSubmit={handleSubmit} onReset={handleReset}>
            <div style={{ marginBottom: '16px' }}>
                <Textfield
                    name="video-description"
                    label={t('editor.video-title')}
                    helper={t('editor.video-title-helper')}
                    value={titleInput}
                    onChange={changeTitleInput}
                />
            </div>
            <Flexer mt>
                <Button type="reset" size="normal" variant="tertiary">
                    {t('action.cancel')}
                </Button>
                <Button type="submit" size="normal" variant="primary">
                    {t('action.save')}
                </Button>
            </Flexer>
        </form>
    )
}

export default VideoProperties
